import { TableProps } from "antd";
import { ColumnsType } from "antd/es/table";
import axios from "axios";
import styles from "react-loading-overlay-ts/dist/styles";
import React from "react";


export function isNull(data:any){
    return data==null;
}
interface Props {
    text: string;
  }

export function isDateSelected(
  indexMonth: any,
  indexYear: any,
  data: any,
  period: any
) {
  // Parse the selected start and end dates
  const [selectedStartYear, selectedStartMonth] = data[0].split('-').map(Number);
  const [selectedEndYear, selectedEndMonth] = data[1].split('-').map(Number);

  // Parse the period start and end dates (assuming they might be used for additional logic later)
  const [periodStartYear, periodStartMonth] = period[0].split('-').map(Number);
  const [periodEndYear, periodEndMonth] = period[1].split('-').map(Number);


  // Check if the current year and month fall within the selected date range
  if (
    (indexYear > selectedStartYear || (indexYear === selectedStartYear && indexMonth >= selectedStartMonth)) &&
    (indexYear < selectedEndYear || (indexYear === selectedEndYear && indexMonth <= selectedEndMonth))
  ) {
    return <p style={{textAlign: 'center'}}>x</p>;
  }

  return <p style={{textAlign: 'center'}}>-</p>;
}

export function isDate(
    indexMonth: any,
    indexYear: any,
    data: any,
    period: any
  ) {
    // Parse the selected start and end dates
    const [selectedStartYear, selectedStartMonth] = data[0].split('-').map(Number);
    const [selectedEndYear, selectedEndMonth] = data[1].split('-').map(Number);
  
    // Parse the period start and end dates (assuming they might be used for additional logic later)
    const [periodStartYear, periodStartMonth] = period[0].split('-').map(Number);
    const [periodEndYear, periodEndMonth] = period[1].split('-').map(Number);
  
  
    // Check if the current year and month fall within the selected date range
    if (
      (indexYear > selectedStartYear || (indexYear === selectedStartYear && indexMonth >= selectedStartMonth)) &&
      (indexYear < selectedEndYear || (indexYear === selectedEndYear && indexMonth <= selectedEndMonth))
    ) {
      return true;
    }
  
    return false
  }

  export const formatNumber = (value: number | string) => {
    if (value == null || value === '') return '-'; // Handle null, undefined, or empty string
    const numericValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numericValue)) return '-'; // Handle invalid number formats
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(numericValue);
};

export function showmonth(month:number){
    let currentmonth='tmp';
    if(month == 1|| month == 13){
        currentmonth='ม.ค.'
    } else if(month == 2|| month == 14){
        currentmonth='ก.พ.'
    }else if(month == 3|| month == 15){
        currentmonth='มี.ค.'
    }else if(month == 4|| month == 16){
        currentmonth='เม.ย.'
    }else if(month == 5|| month == 17){
        currentmonth='พ.ค.'
    }else if(month == 6|| month == 18){
        currentmonth='มิ.ย.'
    }else if(month == 7|| month == 19){
        currentmonth='ก.ค.'
    }else if(month == 8|| month == 20){
        currentmonth='ส.ค.'
    }else if(month == 9|| month == 21){
        currentmonth='ก.ย.'
    }
    else if(month == 10|| month == 22){
        currentmonth='ต.ค.'
    }
    else if(month == 11|| month == 23){
        currentmonth='พ.ย.'
    }
    else if(month == 12|| month == 24){
        currentmonth='ธ.ค.'
    }
    return currentmonth;
}
export const hasNullValues = (obj: Record<string, any>): boolean  => {
    // Check if the argument is an object
    if (typeof obj !== 'object' || obj === null) {
        throw new Error('Input must be a non-null object');
    }

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
        // Check if the value is null or undefined
        if (obj[key] === null || obj[key] === undefined) {
            return true; // Found a null or undefined value
        }
        }
    }
    return false; // No null or undefined values found
  };

export const SplitText = ({ text }: Props) => {
    const temp = text.split('/r'); // Split text by '/'
  
    return (
      <div>
        {temp.map((item, index) => (
          <p key={index}>{item}</p> // Render each part in a <p> tag
        ))}
      </div>
    );
  };

export function periodToString(text: any){
    const x = JSON.parse(text)
    const tmp = x[0].split('-')
    const tmp1 = x[1].split('-')
    const start_year = tmp[0]
    const start_month = tmp[1]
    const end_year = tmp1[0]
    const end_month = tmp1[1]

    return 'ตั้งแต่เดือน '+showmonth(Number(start_month))+' '+start_year+' ถึง '+showmonth(Number(end_month))+' '+end_year
}

export function showyear(year: any,month:any,quarter: any){
    if(year>5000){
        if(quarter==1){
            return 'ไตรมาสที่ 1'
        }else if(quarter==2){
            return 'ไตรมาสที่ 2'
        }else if(quarter==3){
            return 'ไตรมาสที่ 3'
        }else if(quarter==4){
            return 'ไตรมาสที่ 4'
        }
    }else{
        if(month<11){
            if(quarter==1){
                return 'ไตรมาสที่ 1/'+year
            }else if(quarter==2){
                return 'ไตรมาสที่ 2/'+year
            }else if(quarter==3){
                return 'ไตรมาสที่ 3/'+year
            }else if(quarter==4){
                return 'ไตรมาสที่ 4/'+year
            }
        }else{
            if(quarter==1){
                return `ไตรมาสที่ 1/${Number(year) + 1}`
            }else if(quarter==2){
                return `ไตรมาสที่ 2/${Number(year) + 1}`
            }else if(quarter==3){
                return `ไตรมาสที่ 3/${Number(year) + 1}`
            }else if(quarter==4){
                return `ไตรมาสที่ 4/${Number(year) + 1}`
            }
        }
        
    }
}

export function refreshTable(project_id:any){
    axios.get(`${process.env.REACT_APP_API}/get-researcher-team/${project_id}`).then(res =>{
        // axios.get(`${process.env.REACT_APP_API}/get-researcher-team/${local_researcher}`).then(response =>{
          return res.data
        })
}

function getMonthName(monthNumber: number): string {
    const months = [
      "ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.",
      "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."
    ];
  
    // Check if monthNumber is within 1–12 range
    if (monthNumber < 1 || monthNumber > 12) {
      throw new Error("Month number must be between 1 and 12.");
    }
    
    return months[monthNumber - 1]; 
  }

export function monthcolumn(startmonth: number, endmonth: number, period: [string | null, string | null]) {
    const columns: TableProps['columns'] = [];
    const tmp: TableProps['columns'] = []; 

    const getQuarter = (month: number): string => {
        if (month >= 1 && month <= 3) return `ไตรมาสที่ 1`;
        if (month >= 4 && month <= 6) return `ไตรมาสที่ 2`;
        if (month >= 7 && month <= 9) return `ไตรมาสที่ 3`;
        return `ไตรมาสที่ 4`;
    };
    

    const generateMonthColumn = (month: number, year: number) => ({
        title: getMonthName(month),
        render: (_: any, record: any) => {
            const isSelected = isDate(month, year, record.Activitydate, period);
            return {
                children: isDateSelected(month, year, record.Activitydate, period),
                props: {
                    style: { background: isSelected ? "#FDDBBB" : "transparent" }
                },
            };
        },
    });
    
    const addQuarterColumn = (quarter: string, year: string) => {
        if (tmp.length > 0) {
            columns.push({
                title: `${quarter}/${year}`,
                children: [...tmp],
            });
            tmp.length = 0; // Clear array while keeping reference
        }
    };

    if (period && period[0] && period[1]) {
        const [startyear, endyear] = [period[0].split('-')[0], period[1].split('-')[0]];
        for (let year = parseInt(startyear); year <= parseInt(endyear); year++) {
            const isStartYear = year == parseInt(startyear);
            const isEndYear = year == parseInt(endyear);
            const start = isStartYear ? startmonth : 1;
            const end = isEndYear ? endmonth : 12;

            for (let month = start; month <= end; month++) {
                
                const quarter = getQuarter(month);
                tmp.push(generateMonthColumn(month, year));

                // Add quarter column when the month reaches the quarter end or end month
                if ((month % 3 === 0) || month === end) {
                    addQuarterColumn(quarter, year.toString());
                }
            }
        }
    }

    if (columns.length > 0) {
        return columns;
    } else {
        return [{
            title: 'ยังไม่มีข้อมูล',
            align: 'center',
            // Use render method to ensure proper type
            render: () => <div style={{ textAlign: 'center' }}>ยังไม่มีข้อมูล</div>,
        }] as unknown as ColumnsType<any>; // Cast to avoid type error
    }

}

export function mapTypetoName(tmp:number){
    switch(tmp){
        case 1:
            return 'งานวิจัยเชิงวัฒนธรรม'
        case 2:
            return 'งานนวัตกรรม'
        case 3:
            return 'งานวิจัยเพื่อสร้างองค์ประกอบความรู้พื้นฐาน'
        case 4:
            return 'งานวิจัยเชิงประยุกต์'
        case 5:
            return 'งานสร้างสรรค์(หนังสั้น สารคดี โฆษณา)'
        case 6:
            return 'งานวิจัยประเมินหลักสูตร'
        case 7:
            return 'อื่นๆ'
    }
}